import { computed } from "vue"
import { useCurrentUserStore } from "../../pinia/CurrentUserStore";


export const isDeveloperMode = computed(() => {
    let currentUser = useCurrentUserStore();
    if(currentUser.user.is_administrator === "true"){
        return currentUser.debugs.global;
    }else{
        return false;
    }
});


export const additionalInvoiceColumns = computed(() => {
    return [
            {
                key: "id",
                label: "ID",
                display: true
            },
            {
                key: "pdf.0.is_transfered_to",
                label: "Transfered To",
                display: true
            },
            {
                key: "pdf.0.id",
                label: "PDF ID",
                display: true
            },
    ]
})
